import { render, staticRenderFns } from "./JobOrderImport.vue?vue&type=template&id=f80c81e8&scoped=true&"
import script from "./JobOrderImport.vue?vue&type=script&lang=js&"
export * from "./JobOrderImport.vue?vue&type=script&lang=js&"
import style0 from "./JobOrderImport.vue?vue&type=style&index=0&id=f80c81e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80c81e8",
  null
  
)

export default component.exports